import React from "react";
import OurServices from "../OurServices";

function VideoPhone() {
  return (
    <div>
      <OurServices
        hero_title={"Video Door Phone"}
        hero_desc={
          "Your trusted partner in innovative security and office automation solutions."
        }
        about_img_one={
          "https://res.cloudinary.com/ddffnw81j/image/upload/v1743236525/video-door-phone-1_ittmkh.png"
        }
        about_img_one_desc={
          "A Video Door Phone (VDP) is a security device that allows homeowners or businesses to visually and verbally communicate with visitors before granting them access. It consists of an outdoor unit with a camera, microphone, and speaker, and an indoor monitor that displays the visitor’s image and enables two-way communication. Modern video door phones come with high-resolution cameras, night vision capabilities, and motion detection sensors, ensuring security even in low-light conditions."
        }
        about_img_two={
          "https://res.cloudinary.com/ddffnw81j/image/upload/v1743236524/video-door-phone-2_ufg92g.png"
        }
        about_img_two_desc={
          "Some advanced models also support smartphone integration, allowing users to monitor and communicate with visitors remotely. Video door phones enhance safety by preventing unauthorized access, making them an essential security feature for residential apartments, gated communities, offices, and commercial buildings."
        }
        why_desc={
          "With nearly a decade of hands-on experience, we stay updated with the latest advancements in video door phone technology. Our team is dedicated to delivering top-tier video door phone systems that provide both reliability and convenience for your security needs."
        }
        s_one={"Video Door Phone Installation and Setup"}
        s_two={"Maintenance and Support"}
        s_three={"Custom Security Solutions"}
        s_four={"System Upgrades and Integration"}
        f_one_title={"Specialists in Video Door Phone Systems"}
        f_one_desc={
          " Our video door phone systems offer exceptional features, including high-definition video, two-way audio, and remote access. These systems enhance security by allowing you to see and communicate with visitors before granting access."
        }
        f_two_title={"Custom Solutions for Every Requirement"}
        f_two_desc={
          "We understand that every property has unique security needs. Our video door phone solutions are tailored to fit the specific requirements of your home or business, ensuring maximum security and convenience."
        }
        f_three_title={"Seamless Integration with Other Systems"}
        f_three_desc={
          "Our video door phones can be easily integrated with other security systems, such as CCTV cameras and alarm systems, creating a comprehensive security solution that offers complete peace of mind."
        }
        f_four_title={"Reliable Performance and Durability"}
        f_four_desc={
          "At Vitri Enterprises, we offer video door phones built to last. With durable hardware and high-quality performance, our systems are designed to withstand the elements and provide long-lasting security."
        }
        c_one_title={"Serving a Wide Range of Clients"}
        c_one_desc={
          "We are proud to serve a diverse range of clients, from homeowners looking to secure their properties to businesses and institutions needing advanced security solutions. Vitri Enterprises has the expertise to meet the security needs of any establishment."
        }
        c_two_title={"Secure Your Premises with Vitri Enterprises Today!"}
        c_two_desc={
          "Our goal at Vitri Enterprises is to provide you with reliable, user-friendly video door phone systems that enhance your security. Contact us today to get started."
        }
        images={[
          "https://res.cloudinary.com/ddffnw81j/image/upload/v1738831475/vp-2_wsu3ul.jpg",
          "https://res.cloudinary.com/ddffnw81j/image/upload/v1738831475/vp-5_k7dxiz.jpg",
          "https://res.cloudinary.com/ddffnw81j/image/upload/v1738831475/vp-4_gsitol.webp",
          "https://res.cloudinary.com/ddffnw81j/image/upload/v1738831475/vp-3_nrz87m.webp",
          "https://res.cloudinary.com/ddffnw81j/image/upload/v1738831475/vp-1_epjij9.jpg",
          "https://res.cloudinary.com/ddffnw81j/image/upload/v1738831475/vp-6_q1kgc1.png",
        ]}
      />
    </div>
  );
}

export default VideoPhone;
